/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';

import TitlePages from 'components/_base/TitlePages';
import InputTelefone from 'components/_base/InputTelefone';
import {
  GET_APROVADOR_MODEL,
} from 'services/Solicitacao';
//import { GET_USUARIO, UPDATE_TELEFONE } from 'services/Usuario';
import { tabs, passos } from '../_constants';

function Aprovador(props) {
  const {
    userData,
    setLoader,
    updateRascunho,
    model,
    renderErrors,
    setActiveTab,
  } = props;

  const [aprovadorList, setAprovadorList] = useState([]);
  const [aprovadorId, setAprovadorId] = useState({});
  const [disabledSelectAprovador, setDisabledSelectAprovador] = useState(false);

  const errors = (model.errors || []).filter(
    (error) => error.passo === passos.passoAprovador.nro
  );

  useEffect(() => {
    setAprovadorId(parseInt(model.aprovadorId));
  }, [model.aprovadorId]);

  useEffect(() => {
    (async () => {
      setLoader(true);

      // Obtem as informacoes de Aprovadores
      const { value: aprovadorModel } = await GET_APROVADOR_MODEL();

      const listUsuarioAprovador = aprovadorModel?.selectListAprovadores;

      // Aprovadores -------------------------------------------------------------------------------------------
      if(listUsuarioAprovador){
        //setDisabledSelectAprovador(false);
        setAprovadorList(listUsuarioAprovador[0].options);
      }

      setLoader(false);
    })();
  }, []);

  return (
    <div className="wrapper-content-pedido-cliente">
      <TitlePages title="Escolha o Aprovador" />
      <div className="content-pedido-cliente pt-5 mb-5">
        {renderErrors(errors)}
        <div className="row">
          <div className="col-12 text-center mb-5">
            <h4>Selecione abaixo o Aprovador:</h4>
          </div>
          <div className="col-md-6 col-sm-12">
            <label>Escolha o Aprovador</label>
            <Select
              name="colors"
              options={aprovadorList}
              classNamePrefix="select"
              placeholder="Selecione..."
              onChange={(item) => {
                setAprovadorId(parseInt(item.value));
              }}
              isDisabled={disabledSelectAprovador}
              value={aprovadorList.find((item) => parseInt(item.value) === aprovadorId)}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className=" text-left">
          <button
            className="btn btn-primary btn-navigation btn-navigation-left"
            onClick={() => {
              setActiveTab(tabs.tabSolicitacoes);
            }}
          >
            <span>
              <FaAngleLeft size={26} />
            </span>
            <span>VOLTAR</span>
          </button>
        </div>
        <div className=" d-flex flex-row-reverse">
          <button
            className={`btn btn-primary btn-navigation btn-navigation-right
              ${aprovadorId
                ? ''
                : 'btn-disabled'
              }`}
            onClick={() => {
              if (aprovadorId) {
                const aprovador = aprovadorList.find(
                  (item) => parseInt(item.value) === aprovadorId
                );
                model.aprovadorId = aprovadorId;
                model.aprovador = {
                  usuarioId: aprovadorId,
                  nome: aprovador.label,
                };
                //model.usuarioId = userData.userId;
                updateRascunho();
                setActiveTab(tabs.tabResumo);
              }
            }}
          >
            <span>AVANÇAR</span>
            <span>
              <FaAngleRight size={26} />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Aprovador;
